import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";
import ReceipeDetail from "../RequisitionProduction/ReceipeDetail";

const Create = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [kitchen, setKitchen] = useState([]);
  const [rmpm, setRmpm] = useState([]);
  const [factory, setFactory] = useState({});
  const [list, setList] = useState([]);
  const { checkRequiredFields } = useRequiredFields();
  const [receipeNotFound, setReceipeNotFound] = useState("");
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState(null);
  const [kitchenType, setKitchenType] = useState(null);
  const [currentKitchen, setCurrentKitchen] = useState(null);
  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        // const resKitchen = await Http.get("/receipe-finished-good");
        // setKitchen(resKitchen.data);
        const resRole = await Http.get(`/staff-type-check`);
        setRole(resRole.data);
        const resRmpm = await Http.get("/product-wise-stock");
        setRmpm(resRmpm.data.item);
        const resBatchNo = await Http.get(
          "/last-code-increment-by-one/transfer_items/receipt_no/TR",
        );
        const kitchenLists = await Http.get(
          "/staff2?user_type=kitchen",
        );
        setKitchen(kitchenLists.data);
        setInputs((values) => ({ ...values, ["receipt_no"]: resBatchNo.data }));
        Http.get("/me")
          .then((res) => {
            setKitchenType(res.data.data.kitchen_type);
            setLoading(false);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
            setLoading(false);
          });
        getCurrentDateInput();
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    DatatableFunc();
    fetchData();
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleSelectChange = (selectedOption) => {
    setInputs((values) => ({
      ...values,
      kitchen_id: selectedOption ? selectedOption.value : "",
    }));

    // Clear the list when a product is selected (no recipe needed)
    setList([]);
    setReceipeNotFound("");
  };

  const handleCustomInputChange = (e, index, item) => {

    // if(e.target.value > item.stockQty){    
    //       Swal.fire({
    //         title: "Error",
    //         text: `Cannot exceed available stock (${item.stockQty}).`,
    //         icon: "error",
    //         confirmButtonText: "Ok",
    //       });

    //       return;
    // }
    const { name, value } = e.target;
    const inputInfo = [...list];

    inputInfo[index][name] = value;
    setList(inputInfo);
  };

  const getCurrentDateInput = () => {
    const dateObj = new Date();

    // get the month in this format of 04, the same for months
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObj.getDate()).slice(-2);
    const year = dateObj.getFullYear();

    const shortDate = `${year}-${month}-${day}`;

    setInputs((values) => ({ ...values, ["date"]: shortDate }));
    setInputs((values) => ({
      ...values,
      ["expected_production_date"]: shortDate,
    }));

    // Get the current time in the format "HH:mm"
    const hours = ("0" + dateObj.getHours()).slice(-2);
    const minutes = ("0" + dateObj.getMinutes()).slice(-2);

    const defaultTime = `${hours}:${minutes}`;

    setInputs((values) => ({ ...values, ["time"]: defaultTime }));
  };

  // const addMoreList = (id) => {
  //   let exists = false;

  //   // Convert the object into an array using Object.values()
  //   const listArray = Object.values(list);

  //   console.log("listArray", listArray);

  //   listArray.forEach((item) => {
  //     if (parseInt(item.id) === parseInt(id)) {
  //       Swal.fire({
  //         text: "This Product already in the list! Please choose another Product!",
  //         icon: "warning",
  //         showCancelButton: false,
  //         confirmButtonColor: "#3085d6",
  //         cancelButtonColor: "#d33",
  //         confirmButtonText: "Ok",
  //       }).then((result) => {});
  //       exists = true;
  //     }
  //   });
  //   if (!exists) {
  //     Http.get("/add-new-rmpm-receipe/" + id).then((res) => {
  //       console.log(res.data);
  //       setList([...listArray, res.data]);
  //     });
  //   }
  // };
  // const addMoreList = (id) => {
  //   setList((prevList) => {
  //     const index = prevList.findIndex(
  //       (item) => Number(item.product_id) === Number(id),
  //     );

  //     if (index !== -1) {
  //       Swal.fire({
  //         title: "Error!",
  //         text: "This Product already in the list ! Please choose another RMPM.",
  //         icon: "error",
  //         confirmButtonText: "Ok",
  //       });
  //       return prevList;
  //     }
  //     Http.get(`/add-new-rmpm-receipe/${id}`).then((res) => {
  //       setList((current) => [...current, { ...res.data, request_qty: 1 }]);
  //     });

  //     return prevList;
  //   });
  // };

  const addMoreList = (id) => {
    setList((prevList) => {
      if (prevList.some(item => Number(item.product_id || item.id) === Number(id))) {
        Swal.fire({
          title: "Error!",
          text: "This Product already exists in the list.",
          icon: "error",
          confirmButtonText: "Ok",
        });
        return prevList;
      }

      const selectedItem = rmpm.find(
        item => Number(item.id) === Number(id)
      );

      if (!selectedItem) {
        Swal.fire({
          title: "Not found!",
          text: "Item not found in stock list.",
          icon: "warning",
        });
        return prevList;
      }

      return [
        ...prevList,
        {
          ...selectedItem,
          issue_qty: 1,
          description: "",
        },
      ];
    });
  };


  // Remove List
  const removeList = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const inputInfo = [...list]; // Load All Existing experience State Data
        inputInfo.splice(index, 1); // Remove Experience by Index/Click Event Wise
        setList(inputInfo); // Replace Existing experience into State
      }
    });
  };

  const formSubmit = () => {
    checkRequiredFields();

    // Prepare items data only if list has items
    const preparedItems =
      list.length > 0
        ? list.map((item) => ({
          product_id: item.product_id || item.id,
          issue_qty: parseFloat(item.qty) || 0,
          description: item.description || "",
        }))
        : [];

    console.log("preparedItems", preparedItems);

    // Add items to inputs
    const submitData = {
      ...inputs,
      items: preparedItems,
    };

    Http.post("/kitchen-to-kitchen-transfer", submitData)
      .then((res) => {
        navigate("/kitchen-to-kitchen-transfer", {
          state: {
            message: res.data.message,
            type: res.data.type || "success",
          },
        });
      })
      .catch(function (e) {
        if (e.response && e.response.data && e.response.data.errors) {
          setError(e.response.data.errors);
        }
      });
  };
  const displayError = (fieldName) => {
    if (error && error[fieldName]) {
      return <div className="text-danger small">{error[fieldName]}</div>;
    }
    return null;
  };
  const cols = [
    { field: (item) => item.code + " - " + item.name + " - " + item.unit_name, header: "Item" },
    // { field: (item) => item.unit_qty + " " + item.unit_name, header: "Unit" },
    /*...(role === "admin" || role === "kitchen" || role === "kitchen_manager"
      ? (kitchenType === "ac"
        ? [{ field: "ac_conversion_qty", header: "Converted Qty", sortable: false }]
        : kitchenType === "nonac"
          ? [{ field: "non_ac_conversion_qty", header: "Converted Qty", sortable: false }]
          : kitchenType === "hotel_staff"
            ? [{ field: "staff_conversion_qty", header: "Converted Qty", sortable: false }]
            : kitchenType === "bus_staff"
              ? [{ field: "others_conversion_qty", header: "Converted Qty", sortable: false }]
              : [])
      : []),*/
    { field: "stock_qty", header: "Converted Qty" },
  ];

  const actionTemplate = (item, deleteData) => {
    console.log(item);

    return (
      <td className="text-right">
        <button
          className="btn btn-success btn-sm"
          onClick={() => addMoreList(item.id)}
        >
          <i className="fa fa-plus"></i>
        </button>
      </td>
    );
  };

  return (
    <div>
      {/* <LoaderComponent /> */}
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Generate Transfer</h5>
        </div>
        <div className="am-pagebody row d-flex justify-content-evenly">
          <div className="card pd-20 pd-sm-40 col-7">
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Generate Transfer
            </h6>
            <hr></hr>
            {/* <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div> */}
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>
                      Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={inputs.date || ""}
                      onChange={handleChange}
                      placeholder="Input Date"
                      data-required
                    />

                    {displayError("date")}
                  </div>
                  <div className="col-lg">
                    <label>
                      Time <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="time"
                      className="form-control"
                      name="time"
                      value={inputs.time || ""}
                      onChange={handleChange}
                      placeholder="Input Time"
                      data-required
                    />
                    {displayError("time")}
                  </div>
                  <div className="col-lg">
                    <label>
                      Req. No. <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="receipt_no"
                      className="form-control"
                      name="receipt_no"
                      value={inputs.receipt_no || ""}
                      onChange={handleChange}
                      placeholder="Input Receipt No"
                      data-required
                    />
                    {displayError("receipt_no")}
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">
                      Select Kitchen <i className="fa fa-star required"></i>
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={kitchen[0]}
                      name="kitchen_id"
                      options={kitchen}
                      onChange={handleSelectChange}
                      data-required
                    />
                    {displayError("kitchen_id")}
                  </div>
                </div>
                {!(inputs.fg_out > 0) && (
                  <div className="row mt-3">
                    <div className="card-solid">
                      <div className="card-header with-border text-center">
                        <h5 className="card-title mb-0">Items List</h5>
                      </div>
                      <div className="card-body mt-3 p-0 pt-3">
                        <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0">
                          <thead>
                            <tr>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Code
                              </th>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Product
                              </th>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Qty
                              </th>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.from(list).map((x, i) => (
                              <ReceipeDetail
                                key={i}
                                listInfo={x}
                                listSl={i}
                                rmpm={rmpm}
                                kitchenType={kitchenType}
                                role={role}
                                remove={() => removeList(i)}
                                listInputChange={(e) =>
                                  handleCustomInputChange(e, i)
                                }
                              />
                            ))}
                            {receipeNotFound != "" ? (
                              <tr>
                                <td colSpan={5}>
                                  <p
                                    style={{ color: "red" }}
                                    className="text-center mt-3"
                                  >
                                    {receipeNotFound}
                                  </p>
                                </td>
                              </tr>
                            ) : (
                              ""
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Create
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          <div
            className="card pd-20 pd-sm-40 col-4"
            style={{ backgroundColor: "#ffffffc7" }}
          >
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Finished Good
            </h6>
            <hr></hr>

            <ReactDataTable
              cols={cols}
              receiveData={rmpm}
              isLoading={loading}
              actionTemplate={actionTemplate}
            // deleteData={deleteData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;
